<template>
  
    <div ref="sessionCardRef">
        
        <div class="myCenter">

            <div class="w-full">
                
                <card-details-component :mySlot="mySlot" :tokenId="tokenId" :key="dayDate" :isOnline="true"
                :email="email" :userId="userId" :myReload="myReload" :isCard="false" :displayModal="displayModal"
                :book="book" :index="index" :dayDate="dayDate" :cancelBooking="cancelBooking" :booked="booked"
                :showClassPage="showClassPage" :classType="classType" :myClass="myClass"
                :disableButton="disableButton" :makeCardBooked="makeCardBooked"/>
            </div>            
        </div>
    </div>

</template>

<script>

import { RingLoader } from 'vue-spinners-css';

import moment from 'moment';


import componentsHelpers from '../../classes/componentHelpers';

import cardImagesComponent from '../cards-components/CardImages'
import cardDetailsComponent from '../cards-components/ClassPageSessionsDetails'

export default {

    created(){

    },

    mounted(){
        
        // console.log(`myClass: ${JSON.stringify(this.myClass)}`);

        this.setIsBooked(this.dayDate);
    },

    props: {

        myClass:{

            type: Object
        },

        classType: '',

        tokenId: 0,

        email: '',

        userId: 0,

        index: 0,

        classType: '',

        showClassPage: {

            type: Function
        },

         openOneSlotMapModal: {

            type: Function
        },

        disablePage: false,

        disableButton: false,

        isOnline: false,


        dayDate: '',

        mySlot:{

            type: Object
        },

        businessInfo:{
      
            type: Object,
        },

        instructors:{

            type: Array 
        },

        myReload: {

            type: Function
        },

        book: {
            
            type: Function
        },

        cancelBooking: {

            type: Function
        },


        displayModal: {

            type: Function
        },
    },

    components:{

        RingLoader,
        cardImagesComponent,
        cardDetailsComponent
    },

    methods:{

        // callShowDescription(){

        //     // console.log(`in callShowDescription`);

        //     // console.log(`here ${JSON.stringify(this.mySlot)}`);
        //     this.showDescription(this.mySlot);
        // },

        makeCardBooked(){

            this.booked = true;

            // console.log(`value is: ${this.booked}`)
        },

         setIsBooked(dayDate){
            
            this.myDayDate = dayDate;

            for (let i = 0; i < this.mySlot.bookings.length; i++){

                const booking = this.mySlot.bookings[i];

                if(booking.user_id == this.userId)
                {

                    if(this.myDayDate == booking.day_date){

                        if(this.myDayDate != moment(new Date()).format(moment.HTML5_FMT.DATE)){
                            
                            this.$refs.sessionCardRef.style.backgroundColor = "#48bb78";
                            
                            this.booked = true;

                            this.bookingId = booking.id;

                            return;
                        }

                        // console.log(`id: ${booking.id}, booking date: ${booking.day_date} &&  searching day ${this.myDayDate}`);

                        const timeNow = moment(new Date());

                        const startTime = moment(this.startTime, 'hh:mm a');
                        const endTime = moment(this.endTime, 'hh:mm a');
                        
                        if(moment(timeNow).isSameOrAfter(startTime)){

                            
                            if(moment(timeNow).isBefore(endTime)){

                                this.$refs.sessionCardRef.style.backgroundColor = "#ed8936";
                            }
                            else{

                                this.$refs.sessionCardRef.style.backgroundColor = "#90cdf4";
                            }
                        }
                        else{

                            this.$refs.sessionCardRef.style.backgroundColor = "#48bb78";
                        }

                        this.booked = true;

                        this.bookingId = booking.id;
                        return;
                    }
                }
            }
                // console.log(`finished setisbooked`);
        },
    },

    data: function(){

    return{

        loading:false,  
        booked: false,
        myDayDate: this.dayDate,
        cardImages:[],
        modalImages: [],
        booked: false,
    }
    },

}
</script>

<style>

</style>